import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOrganizationByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Organizations_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdateOrganizationByIdMutation = { __typename?: 'mutation_root', update_organizations_by_pk?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null, jurisdiction_id?: any | null, organizationImageURL?: string | null, workspace_id: any, created_at?: any | null, updated_at?: any | null, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, ahj_type: string } | null } | null };


export const UpdateOrganizationByIdDocument = gql`
    mutation updateOrganizationById($set: organizations_set_input, $id: uuid!) {
  update_organizations_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    name
    contact_name
    email
    type
    jurisdiction_id
    jurisdiction {
      id
      name
      short_name
      state
      ahj_type
    }
    organizationImageURL
    workspace_id
    created_at
    updated_at
  }
}
    `;
export type UpdateOrganizationByIdMutationFn = Apollo.MutationFunction<UpdateOrganizationByIdMutation, UpdateOrganizationByIdMutationVariables>;

/**
 * __useUpdateOrganizationByIdMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationByIdMutation, { data, loading, error }] = useUpdateOrganizationByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrganizationByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationByIdMutation, UpdateOrganizationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationByIdMutation, UpdateOrganizationByIdMutationVariables>(UpdateOrganizationByIdDocument, options);
      }
export type UpdateOrganizationByIdMutationHookResult = ReturnType<typeof useUpdateOrganizationByIdMutation>;
export type UpdateOrganizationByIdMutationResult = Apollo.MutationResult<UpdateOrganizationByIdMutation>;
export type UpdateOrganizationByIdMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationByIdMutation, UpdateOrganizationByIdMutationVariables>;